// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file model/dto_sharing.proto (package com.diagnocat.model, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { Created, Revision } from "./dto_base_pb.js";

/**
 * @generated from enum com.diagnocat.model.SharingInvitationStatus
 */
export const SharingInvitationStatus = proto3.makeEnum(
  "com.diagnocat.model.SharingInvitationStatus",
  [
    {no: 0, name: "SharingInvitationStatus_Pending"},
    {no: 1, name: "SharingInvitationStatus_Accepted"},
    {no: 2, name: "SharingInvitationStatus_Cancelled"},
    {no: 3, name: "SharingInvitationStatus_Deleted"},
  ],
);

/**
 * @generated from message com.diagnocat.model.SharingInvitation
 */
export const SharingInvitation = proto3.makeMessageType(
  "com.diagnocat.model.SharingInvitation",
  () => [
    { no: 1, name: "ID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "OrganizationID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "PatientID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "Recipient", kind: "message", T: SharingInvitationRecipient },
    { no: 6, name: "TargetDetails", kind: "message", T: SharingInvitationTargetDetails },
    { no: 7, name: "Status", kind: "enum", T: proto3.getEnumType(SharingInvitationStatus) },
    { no: 8, name: "Comment", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "Secret", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "AutoAccept", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10030, name: "Created", kind: "message", T: Created },
    { no: 10040, name: "Revision", kind: "message", T: Revision },
  ],
);

/**
 * @generated from message com.diagnocat.model.SharingInvitationRecipient
 */
export const SharingInvitationRecipient = proto3.makeMessageType(
  "com.diagnocat.model.SharingInvitationRecipient",
  () => [
    { no: 1, name: "UserID", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "Phone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "Email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message com.diagnocat.model.SharingInvitationTargetDetails
 */
export const SharingInvitationTargetDetails = proto3.makeMessageType(
  "com.diagnocat.model.SharingInvitationTargetDetails",
  () => [
    { no: 1, name: "OrganizationName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "PatientFirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "PatientLastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "SenderFirstName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "SenderLastName", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "SenderEmail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

